import React from "react";
import { PreviewContainer } from "../../../containers";
const Overview = (props) => {
  return <PreviewContainer {...props} />;
};

export default Overview;
